// extracted by mini-css-extract-plugin
export default {"category-heading":"CategoryList_category-heading__XBYEP"};